import { Button, Input, Picker, t } from "owc-react-lib-common";
import React from "react";
import { InputDate } from "src/components/InputDate";
import { RadioGroup } from 'src/components/RadioGroup';
import { Row } from "src/components/Row/Row";
import { Text } from "src/components/Text";
import { View } from "src/components/View";
import { IValidationParams, NUMBER, REQUIRED, useValidation } from "src/hooks/useValidation";
import { SCHEMA_GROUP_TYPE_LEAGUE, SCHEMA_GROUP_TYPE_KNOCKOUT } from "../../../config";

export const ConfigGroupsApplySchema = ({ onSave, group, onGroupChange }: { onSave: any; group: any; onGroupChange: (field: string, value: any) => void }) => {
  const [formState, setFormState] = React.useState<any>({ ...group });
  const [updateGameOrder, setUpdateGameOrder] = React.useState(group.gamesOrder || []);
  const [errors, setErrors] = React.useState<any>({});
  const { validateAll } = useValidation();

  const best = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
  ];

  const validate = React.useCallback(() => {
    // Declarar fields aquí
    let fields: IValidationParams[] = [];

    // Condición para validar según idType
    if (formState.idType === SCHEMA_GROUP_TYPE_LEAGUE) {
      fields = [
        { name: "groupName", type: REQUIRED },
        { name: "firstRoundDate", type: REQUIRED },
        { name: "repeatType", type: REQUIRED },
        { name: "repeat", type: [REQUIRED, NUMBER] },
      ];
    }
    else {
      fields = [
        { name: "groupName", type: REQUIRED },
        { name: "bestOf", type: REQUIRED },
        { name: "gamesOrder", type: REQUIRED },
      ];
    }

    const { errors, hasErrors } = validateAll(formState, fields);
    setErrors(errors);
    return !hasErrors;
  }, [validateAll, formState]);

  const onValidate = React.useCallback(async () => {
    if (!validate()) {
      return;
    }
    onSave(formState);
  }, [validate, formState, onSave]);

  const handleChange = (field: string, value: any) => {
    setFormState((prev: any) => {
      const updated = { ...prev, [field]: value };
      onGroupChange(field, value);
      return updated;
    });

    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleBestOfChange = (value: number) => {
    const bestOfArr = [];

    for (let i = 0; i < value; i++) {
      bestOfArr.push(((i + 1) % 2 === 0) ? "V" : "L");
    }

    setUpdateGameOrder(bestOfArr);
    handleChange("bestOf", bestOfArr);
    handleChange("gamesOrder", bestOfArr);
  };

  if (group.idType === SCHEMA_GROUP_TYPE_KNOCKOUT) {
    return (
      <View>
        <Text bold fontSize={15} style={{ paddingBottom: 20 }}>{t('admin.schema.configGroupsApplySchema.knockoutConfiguration')}</Text>

        <View style={{ flexDirection: "row", alignItems: "center", gap: 15 }}>
          <Input
            label={t("admin.schema.configGroupsApplySchema.groupName")}
            defaultValue={formState.groupName}
            onChange={(val) => handleChange("groupName", val)}
            error={errors.groupName}
            containerStyle={{ flex: 1}}
            required
          />

          <Picker
            error={errors.bestOf}
            label={t("admin.schema.configGroupsApplySchema.bestOf")}
            items={best}
            defaultValue={formState.bestOf?.length ?? updateGameOrder.length ?? 1}
            onChange={handleBestOfChange}
            containerStyle={{ width: 120 }}
            required
          />
        </View>

        <View flexDirection="row">
          {updateGameOrder?.map((e, i) => (
            <RadioGroup
              key={i}
              label={`${t("admin.schema.configGroupsApplySchema.round")} ${i + 1}`}
              defaultValue={e}
              value={e}
              items={[
                { label: "L", value: "L" },
                { label: "V", value: "V" },
              ]}
              onChange={(value) => {
                const ugo = [...updateGameOrder];
                ugo[i] = value;
                setUpdateGameOrder(ugo);
                handleChange("gamesOrder", ugo);
              }}
              error={errors.gamesOrder}
            />
          ))}
        </View>

        <Button text={t("global.save")} onPress={() => onValidate()} />
      </View>
    );
  }

  return (
    <View>
      <View key={formState.idSchemaGroup} style={{ marginBottom: 20 }}>
        <Text bold fontSize={15} style={{ paddingBottom: 20 }}>{t('admin.schema.configGroupsApplySchema.leagueConfiguration')}</Text>

        <Input
          label={t("admin.schema.configGroupsApplySchema.groupName")}
          defaultValue={formState.groupName}
          onChange={(val) => handleChange("groupName", val)}
          error={errors.groupName}
          required
        />

        <Text bold fontSize={15} style={{ paddingVertical: 5 }}>{t('admin.schema.configGroupsApplySchema.dateConfiguration')}</Text>

        <Row flex={[1, 2, 2]}>
          <InputDate
            label={t("admin.schema.configGroupsApplySchema.firstRoundDate")}
            useTime
            internalFormat="ISOString"
            defaultValue={formState.firstRoundDate}
            onChange={(val) => handleChange("firstRoundDate", val)}
            error={errors.firstRoundDate}
            required
          />

          <Picker
            label={t("admin.schema.configGroupsApplySchema.repeatTypetitle")}
            items={[
              { value: 1, label: t("admin.schema.configGroupsApplySchema.repeatTypedaily") },
              { value: 2, label: t("admin.schema.configGroupsApplySchemaweekly") },
            ]}
            defaultValue={formState.repeatType}
            onChange={(val) => handleChange("repeatType", val)}
            error={errors.repeatType}
            required
          />

          <Input
            label={t("admin.schema.configGroupsApplySchema.repeat")}
            keyboardType="numeric"
            defaultValue={formState.repeat}
            onChange={(val) => handleChange("repeat", val)}
            error={errors.repeat}
            required
          />
        </Row>
      </View>

      <Button text={t("global.save")} onPress={() => onValidate()} />
    </View>
  );
};
